import { Button, Stack, Typography } from "@mui/material";

export default function ErrorPage() {
  return (
    <Stack textAlign="center" height="100vh">
      <Stack my="auto" textAlign="center" justifyContent="center">
        <Stack mb={2}>
          <Typography variant="h2">Woops!</Typography>
          <Typography variant="h4">Something went wrong :(</Typography>
        </Stack>
        <Stack direction="row" textAlign="center" justifyContent="center" width="100%" gap={2}>
          <Button variant="contained" color="primary" onClick={() => window.location = '/'}>Go Home</Button>
          <Button variant="contained" color="secondary" onClick={() => window.location.reload()}>Reload</Button>
          <Button variant="contained" color="error" onClick={() => window.location = '/logout'}>Logout</Button>
        </Stack>
      </Stack>
    </Stack>
  );
}